import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicePage from "../pages/service/page";
import SystemPage from "../pages/system/page";
import IntroductionFlowPage from "../pages/introduction-flow/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import PrivacyPage from "../pages/privacy/page";
import DemoPage from "../pages/demo/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/service", element: <ServicePage /> },
  { path: "/system", element: <SystemPage /> },
  { path: "/introduction-flow", element: <IntroductionFlowPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/demo", element: <DemoPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
